import React, { useEffect } from 'react';
import gtmIds from 'adapter/in/dashboards/config/gtm';
import { useDashboard } from 'adapter/in/dashboards/context/Dashboard';
import { useDashboards } from 'adapter/in/dashboards/context/Dashboards';
import Dashboard from 'domain/entity/dashboard';
import { isSome } from 'fp-ts/lib/Option';
import { Button, colors } from '@dexma/ui-components';
import { UpdateDashboardStarCriteriaBuilder } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardStarCriteria';

const gtm = gtmIds.dashboards.table;

export const useDashboardsStarColumn = () => {
    const { updateStar, updateStarReset, updateStarResult } = useDashboard();
    const { getReset } = useDashboards();

    useEffect(() => {
        if (isSome(updateStarResult)) {
            updateStarReset();
            getReset();
        }
    }, [updateStarResult]);

    const onStar = (dashboard: Dashboard) => {
        updateStar(UpdateDashboardStarCriteriaBuilder.create().withId(dashboard.id).withStarred(!dashboard.starred).build());
    };

    return {
        column: {
            title: '',
            dataIndex: '',
            width: '2.5%',
            className: 'background-none remove-border no-padding',
            render: (dashboard: Dashboard) => (
                <Button
                    variant='icon-secondary'
                    iconAfter='star'
                    isCircle
                    size='large'
                    onClick={() => onStar(dashboard)}
                    data-testid='star'
                    dataId={gtm.actions.star}
                    iconColor={dashboard.starred ? colors.amber : undefined}
                />
            ),
        },
    };
};
